// @import

import { ensureHTMLElement } from "@src/js/lib/ensure";
import { viewport } from "@src/js/lib/viewport";
import Alpine from "alpinejs";
import EmblaCarousel from "embla-carousel";

Alpine.directive("related-news", (element, {}, { cleanup, effect }) => {
  const viewportEl = ensureHTMLElement(element.querySelector(".single-news__related-slider-viewport"));

  let slider: ReturnType<typeof EmblaCarousel> | null = null;

  effect(() => {
    if (viewport.width < 1024) {
      initSlider();
    } else {
      destroySlider();
    }
  });

  function destroySlider() {
    if (slider) {
      slider.destroy();
      slider = null;
    }
  }

  function initSlider() {
    if (!slider) {
      slider = EmblaCarousel(viewportEl, { align: "start" });
    }
  }

  cleanup(() => {
    destroySlider();
  });
});
